const parsePairedProducts = (pairedProductsString) => {
    if (!pairedProductsString) return []

    return pairedProductsString.split(',').map((product) => {
        const trimmedProduct = product.trim()

        if (trimmedProduct.includes('x')) {
            const [quantity, code] = trimmedProduct.split('x')
            return { qty: parseInt(quantity), code } // Object property shorthand
        }
        return { qty: 1, code: trimmedProduct }
    })
}

const findParameter = (labelText, hide = true) => {
    const parameters = [...document.querySelectorAll('.detail-parameters-wrapper .detail-parameters tr')]

    const parameter = parameters.find((param) => {
        const label = param.querySelector('th .row-header-label')?.textContent.trim()
        return label === labelText
    })

    if (parameter) {
        if (hide) parameter.classList.add('hide')
        return parameter.querySelector('td').textContent?.trim()
    }
    return null
}

// const pairedProductsParameter = findParameter('Sada produktů:', false)
const pairedProducts = findParameter('Sada produktů:')
const parsedProducts = parsePairedProducts(pairedProducts)

export const initSetProducts = () => {
    const pairedProductsParameter = findParameter('Sada produktů:', false)
    if (!pairedProductsParameter) return

    document.body.classList.add('set-products-loaded')

    const priceWrapper = /*HTML*/ `
        <div class="p-final-price-wrapper set-products-price">
            <strong class="price-final">
                <span class="price-final-holder"></span>
            </strong>
        </div>
    `
    $(priceWrapper).insertAfter('.p-final-price-wrapper')

    $('.add-to-cart .amount').attr('max', 1)

    // Modern async/await pattern
    const initialize = async () => {
        const data = await fetchAllProductData()

        const updateUI = () => {
            checkAvailability(data)
            calculatePrice(data)
        }

        updateUI()

        // Event listeners using arrow functions
        document.addEventListener('ShoptetSplitVariantParameterChange', () => setTimeout(updateUI, 150))

        const amountInput = $('.add-to-cart .amount')
        amountInput.on('input change', function () {
            const max = parseInt($(this).attr('max')) || Infinity
            if (parseInt($(this).val()) > max) {
                $(this).val(max)
            }
            setTimeout(updateUI, 150)
        })

        $('.p-basic-info-block .block:has(.availability-label), .p-final-price-wrapper').addClass('ready')
    }

    initialize()

    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', () => {
        const setProductName = getShoptetDataLayer('product').name
        const productName = $(".h2[data-testid='textPopupProductName']")
        productName.text(setProductName)
    })
}

const fetchProductData = async (searchString) => {
    try {
        const response = await fetch(`/kereses/?string=${encodeURIComponent(searchString)}`, {
            headers: {
                Accept: 'text/html',
                'Content-Type': 'text/html',
            },
        })

        const html = await response.text()
        const doc = new DOMParser().parseFromString(html, 'text/html')

        const productName = doc.querySelector('#products-found .p-in-in .name')?.textContent.trim()
        const priceElement = doc.querySelector('#products-found .price.price-final')
        const availabilityElement = doc.querySelector('#products-found .availability .availability-amount')

        const stock = availabilityElement ? parseInt(availabilityElement.textContent.match(/\d+/)[0]) : 0

        const price = priceElement
            ? parseFloat(priceElement.textContent.replace(/[^\d.,]/g, '').replace(',', '.'))
            : null

        return {
            name: productName,
            code: searchString,
            price,
            inStock: stock > 0,
            stock,
        }
    } catch (error) {
        console.error('Error fetching product data:', error)
        return {
            code: searchString,
            price: null,
            inStock: false,
        }
    }
}

const getEveryRelatedProductCodes = () => [
    ...parsedProducts.map((product) => product.code),
    ...Object.values(productDiskCodeMap),
]

const fetchAllProductData = async () => {
    const searchCodes = getEveryRelatedProductCodes()
    return Promise.all(searchCodes.map(fetchProductData))
}

function addToCart(e) {
    const selectedValue = $('#parameter-id-44').val()
    const selectedDiskCode = productDiskCodeMap[selectedValue]
    const cartAmountQty = parseInt($('.add-to-cart .amount').val())

    console.log('cart')

    if (selectedValue.trim().length === 0) return

    e.preventDefault()

    console.log('--- Adding to Cart ---')

    // Add parsed products
    parsedProducts.forEach((item) => {
        const totalQtyNeeded = item.qty * cartAmountQty

        shoptet.cartShared.addToCart({
            productCode: item.code,
            amount: totalQtyNeeded,
        })
    })

    // Add disk if selected
    if (selectedDiskCode) {
        shoptet.cartShared.addToCart({
            productCode: selectedDiskCode,
            amount: cartAmountQty,
        })
    }
}

const checkAvailability = (data) => {
    const selectedValue = $('#parameter-id-44').val()
    const amountInput = $('.add-to-cart .amount')
    let cartAmountQty = Math.max(1, parseInt(amountInput.val()) || 1)
    amountInput.val(cartAmountQty)

    // Handle initial state
    const noVariantSelected =
        !$('.variant-list.variant-selected').length && $('.set-products-availability').length === 0

    if (noVariantSelected) {
        const availabilityHTML = /*HTML*/ `
            <span class="set-products-availability-wrapper">
                <span class="availability-label set-products-availability">
                    Kérjük, válasszon változatot
                </span>
            </span>
        `
        $('.p-basic-info-block .block:first').append(availabilityHTML)
    }

    // Handle empty selection
    if (!selectedValue.trim()) {
        const availability = $('.set-products-availability')
        const wrapper = $('.set-products-availability-wrapper')

        amountInput.attr('max', 1).val(1)
        wrapper.find('.availability-amount').remove()
        availability.removeAttr('style').text('Kérjük, válasszon változatot')
        return
    }

    // Get disk data
    const selectedDiskCode = productDiskCodeMap[selectedValue]
    const selectedDiskData = data.find((item) => item.code === selectedDiskCode)

    console.log('--- Availability Check ---')

    // Calculate availability for products
    const maxSets = []
    const isAvailable = parsedProducts.every((parsedProduct) => {
        const productData = data.find((item) => item.code === parsedProduct.code)
        const maxPossibleSets = Math.floor(productData.stock / parsedProduct.qty)
        maxSets.push(maxPossibleSets)

        const currentNeed = parsedProduct.qty * cartAmountQty

        return productData?.inStock && productData.stock >= currentNeed
    })

    // Handle disk availability
    if (selectedDiskCode && selectedDiskData) {
        maxSets.push(selectedDiskData.stock)
    }

    const absoluteMaxSets = Math.min(...maxSets)

    // Update amount input constraints
    amountInput.attr('max', absoluteMaxSets)
    if (cartAmountQty > absoluteMaxSets) {
        amountInput.val(Math.max(1, absoluteMaxSets))
        cartAmountQty = Math.max(1, absoluteMaxSets)
    }

    const isDiskAvailable =
        !selectedDiskCode || (selectedDiskData?.inStock && selectedDiskData.stock >= cartAmountQty)

    // Update UI
    const $availabilityLabel = $('.availability-label.set-products-availability')
    const $wrapper = $('.set-products-availability-wrapper')

    if (!isAvailable || !isDiskAvailable) {
        console.log('Result: Product is unavailable')
        $wrapper.find('.availability-amount').remove()
        $availabilityLabel.text('Nincs raktáron')
        $availabilityLabel.removeAttr('style')

        // Remove any existing click handlers first
        $('.p-add-to-cart-wrapper .add-to-cart-button').off('click')
        // Add the unavailable handler
        $('.p-add-to-cart-wrapper .add-to-cart-button').on('click', function (e) {
            e.preventDefault()
            showMessage('Nincs raktáron', 'error')
        })
    } else {
        console.log('Result: Product is available')
        $availabilityLabel.css('color', '#009901').text('Raktáron')
        $wrapper.find('.availability-amount').remove()

        const amountHTML = /*HTML*/ `
            <span class="availability-amount">(${absoluteMaxSets}&nbsp;db)</span>
        `
        $(amountHTML).insertAfter($availabilityLabel)

        // Remove any existing click handlers first
        $('.p-add-to-cart-wrapper .add-to-cart-button').off('click')
        // Add the available handler
        $('.p-add-to-cart-wrapper .add-to-cart-button').on('click', (e) => addToCart(e))
    }
}

const calculatePrice = (data) => {
    const selectedValue = $('#parameter-id-44').val()
    const cartAmountQty = parseInt($('.add-to-cart .amount').val()) || 1

    console.log('--- Price Calculation ---')

    // Calculate base products price
    const baseProductsPrice = parsedProducts.reduce((total, parsedProduct) => {
        const productData = data.find((item) => item.code === parsedProduct.code)
        const totalQtyNeeded = parsedProduct.qty * cartAmountQty
        const productTotalPrice = productData.price * totalQtyNeeded

        return total + productTotalPrice
    }, 0)

    // Calculate disk price if selected
    const selectedDiskCode = productDiskCodeMap[selectedValue]
    const diskPrice = selectedDiskCode
        ? (() => {
              const diskData = data.find((item) => item.code === selectedDiskCode)
              const diskTotalPrice = diskData.price * cartAmountQty

              return diskTotalPrice
          })()
        : 0

    const totalPrice = baseProductsPrice + diskPrice
    console.log(`Final total price: ${totalPrice} Ft`)

    // Update UI
    $('.set-products-price .price-final-holder').text(totalPrice.ShoptetFormatAsCurrency())
}

async function getExcelData() {
    try {
        // Fetch the Excel file
        const response = await fetch('/user/documents/upload/updated_prices.xlsx')
        const arrayBuffer = await response.arrayBuffer()

        // Parse the Excel file using XLSX
        const data = new Uint8Array(arrayBuffer)
        const workbook = XLSX.read(data, { type: 'array' })

        // Get the first worksheet
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]]

        // Convert to JSON
        const jsonData = XLSX.utils.sheet_to_json(firstSheet)

        return jsonData
    } catch (error) {
        console.error('Error fetching or parsing Excel file:', error)
        return null
    }
}

function transformSetProducts(excelData) {
    const products = document.querySelectorAll('.products .product')

    products.forEach((product) => {
        const pCode = product.querySelector('.p-code span')?.textContent
        const price = product.querySelector('.price.price-final strong')

        if (!pCode) return

        const matchingData = excelData.find((item) => item.code === pCode)

        if (matchingData) {
            if (matchingData.maxAvailableSets && matchingData.maxAvailableSets !== '') {
                const availabilityElement = product.querySelector('.availability-amount')
                if (availabilityElement) {
                    availabilityElement.textContent = `(${matchingData.maxAvailableSets} db)`
                }
            }

            if (price) {
                price.textContent = price.textContent.replace('Ft', 'Ft-tól')
            }
        }
    })
}

function initCategorySetProducts() {
    // Usage
    getExcelData().then((data) => {
        if (data) {
            transformSetProducts(data)
        }
        document.addEventListener('ShoptetDOMPageContentLoaded', function () {
            transformSetProducts(data)
        })
        document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
            transformSetProducts(data)
        })
        document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function () {
            transformSetProducts(data)
        })
    })
}

if ($('.admin-logged').length) {
    initCategorySetProducts()
}
